import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ReleaseService {

  constructor(public http: HttpClient) { }

  releaseHistoryList(sortOder=undefined, searchKey=undefined ) {
    let url = environment.identity_service_api +  'release/cira_release_history_list?sort_order=' + sortOder 
    
    if(searchKey) {
      url += '&search_key=' + searchKey
    }
    
     return this.http.get(url)
  }

}
